import { ReactNode } from 'react'
import { RefCallBack } from 'react-hook-form'
import styled from 'styled-components'

const FOCUSABLE = 'input, textarea, button, [tabindex]:not([tabindex="-1"])'

// Note: `display: contents` keeps the wrapper out of the layout (grids, flex rows)
const Contents = styled.div({
  display: 'contents',
})

interface FocusTargetProps {
  children: ReactNode
  fieldRef: RefCallBack
}

// Note: RHF focuses the first invalid field through the ref it registered. A composite control (select,
// picker, upload) has no single element to register, so this registers one that focuses the first
// focusable element inside it
export const FocusTarget = ({ children, fieldRef }: FocusTargetProps) => (
  <Contents
    ref={(element: HTMLDivElement | null) =>
      fieldRef(element && { focus: () => element.querySelector<HTMLElement>(FOCUSABLE)?.focus() })
    }
  >
    {children}
  </Contents>
)
